import cookieConsent from "./cookie-consent";
import cookieConsentInitializer from "./cookie-consent/cookieConsentInitializer";
import { registerGlobal } from "./utils/registerGlobal";
import { getRegisteredGlobal } from "./utils/getRegisteredGlobal";

export default function () {
    if (getRegisteredGlobal("trumpf.ux.uiCookieConsent") === undefined) {
        registerGlobal(
            cookieConsent,
            ["trumpf", "ux", "uiCookieConsent"],
            window
        );
        cookieConsentInitializer();
    }
}
